
    export default {
      mounted() {
        this.bindThumb()
      },
      updated() {
        this.bindThumb()
      },
      bindThumb() {
        const src = this.el.getAttribute("src") || ""
        if (this._boundSrc === src) return
        this._boundSrc = src
        this.el.classList.remove("is-missing")
        const done = (ev) => {
          this.el.classList.remove("is-pending")
          if (ev && ev.type === "error") this.el.classList.add("is-missing")
        }
        if (this.el.complete && this.el.naturalWidth > 0) {
          done()
          return
        }
        if (this.el.complete) {
          done({type: "error"})
          return
        }
        this.el.classList.add("is-pending")
        this.el.addEventListener("load", done, {once: true})
        this.el.addEventListener("error", done, {once: true})
      }
    }
  